var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinnedon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.139,
    height: 25.693,
    viewBox: "0 0 22.139 25.693",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pinned",
    transform: "translate(1.561 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7084",
    "data-name": "Path 7084",
    d: "M9.975,0S7.891,2.027,5.818,4.157C3.054,3.146,0,5.627,0,5.627l7.685,7.685S9.527,10.283,9.3,7.64c2.082-1.979,4.157-4.157,4.157-4.157",
    transform: "translate(0 12.088) rotate(-45)",
    fill: "none",
    stroke: "#1d3378",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_63729",
    "data-name": "Line 63729",
    x2: 7.151,
    y2: 7.151,
    transform: "translate(4.42 5.057) rotate(-45)",
    fill: "none",
    stroke: "#1d3378",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_63730",
    "data-name": "Line 63730",
    y2: 5.617,
    transform: "translate(9.449 16.499)",
    fill: "none",
    stroke: "#1d3378",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinnedon);
export default __webpack_public_path__ + "static/media/pinnedon.18dad0666e7ec35e7947985fbac196e5.svg";
export { ForwardRef as ReactComponent };